module.exports = __webpack_public_path__ + "img/五倍子.11754b50.jpg";